import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-y border-gold/40 bg-ivory" data-id="element-26" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-27" data-mp="vu7g8amai98x">
        <Reveal className="text-center" data-id="element-28" data-mp="qsrt8d0jxsnw">
          <h2 id="bonos" className="font-display text-lg font-black uppercase leading-tight text-navy sm:text-2xl lg:text-3xl" data-id="element-29" data-mp="qvw7y4bn86st">
            5 Bonos incluidos
          </h2>
          <p className="mt-1 text-[0.8rem] font-bold text-royal sm:text-[0.95rem]" data-id="element-30" data-mp="zsn92v51ybu9">
            Y además recibes 5 recursos prácticos — GRATIS con tu compra.
          </p>
        </Reveal>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-31" data-mp="19mdufr5vu65q">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-gold/60 bg-white p-3" data-id="element-32" data-mp="1nhpnlu4e3okj" data-mpi={i}>
              <span className="self-start rounded bg-navy px-2 py-0.5 text-[0.62rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.68rem]" data-id="element-33" data-mp="3trnj5ibb3k9u">
                {bono.label}
              </span>
              <h3 className="mt-1.5 font-display text-[0.85rem] font-bold uppercase leading-tight text-navy sm:text-[0.92rem]" data-id="element-34" data-mp="7kfkszyt0dnb">
                {bono.title}
              </h3>
              <p className="mt-1 text-[0.73rem] leading-snug text-navy sm:text-[0.8rem]" data-id="element-35" data-mp="chz7mo9khyqv">
                {bono.desc}
              </p>
              <p className="mt-auto pt-2 text-[0.72rem] font-bold text-navy/80 line-through sm:text-[0.78rem]" data-id="element-36" data-mp="lbls3i8brfkr">
                Valor: {bono.value}
              </p>
            </Reveal>)}

          <Reveal as="li" delay={0.16} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-gold bg-navy p-3 text-center" data-id="element-37" data-mp="vatawkxtw2f9">
            <p className="font-sans text-[0.78rem] font-extrabold uppercase leading-tight text-ivory sm:text-[0.85rem]" data-id="element-38" data-mp="akfqsrfjmqaf">
              💰 Valor total de los 5 bonos:
            </p>
            <p className="font-display text-3xl font-black text-white line-through decoration-danger decoration-2 sm:text-4xl" data-id="element-39" data-mp="kas9sf7pmbeg">
              {BONUS_VALUE}
            </p>
            <p className="mt-1 font-display text-sm font-black uppercase leading-tight text-gold sm:text-lg" data-id="element-40" data-mp="fih6r3hoa9ho">
              🔥 Hoy los 5 están incluidos gratis.
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}